import { render, staticRenderFns } from "./TwApprovalRequest.vue?vue&type=template&id=25ea1c10&scoped=true&"
import script from "./TwApprovalRequest.vue?vue&type=script&lang=js&"
export * from "./TwApprovalRequest.vue?vue&type=script&lang=js&"
import style0 from "./TwApprovalRequest.vue?vue&type=style&index=0&id=25ea1c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ea1c10",
  null
  
)

export default component.exports